module.exports = __webpack_public_path__ + "static/media/destinationInfoSkeletonLg.a92eec92.svg";